import { EHomeActions } from './enums';
import { getHome } from './services';

export const getHomeAction = () => ({
    type: EHomeActions.GET_HOME,
    payload: getHome()
});
